import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormHelperText, IconButton, TextField, Typography } from "@mui/material";
import * as Icon from '@mui/icons-material';
import { UserAuth } from "../../store/context/userContext";
import { useNavigate } from "react-router";
import config from "../../config";


const ArchivedAcountSupportPopUp = () => {
    const navigate = useNavigate()
    const { openArchivedSupportPopUp, setOpenArchivedSupportPopUp, archivedAccountResponce } = UserAuth();

    const parts = archivedAccountResponce.split(/(contact@farwide\.com)/);

    const handleCloseClick = () => {
        setOpenArchivedSupportPopUp(false);

        const currentPath = window.location.pathname;
        // Define paths that shouldn't redirect
        const noRedirectPaths = ['/', '/landowner',];
        const noRedirectKeywords = ['app', 'search', 'package', 'experience', 'conservationtrust', 'ourstory', 'contactus', 'aboutus'];

        // Check if current path matches any no-redirect conditions
        const shouldNotRedirect =
            noRedirectPaths.includes(currentPath) ||
            noRedirectKeywords.some(keyword => currentPath.includes(keyword));

        if (shouldNotRedirect) {
            return;
        }

        // Determine which landing page to redirect to
        const isLandowner = currentPath.includes('landowner');
        window.location.href = config.module === 'lister' ? '/landowner' : '/';
    };
    return (
        <>
            <Dialog
                open={openArchivedSupportPopUp}
                maxWidth='sm'
                sx={{
                    // "& .MuiPaper-root": {
                    //     display: 'flex',
                    //     borderRadius: '1rem',
                    //     maxWidth: 'lg',
                    //     width: '100%'
                    // },
                    // width: '100%',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        gap: 1,
                        alignItems: 'center',
                        paddingTop: 3
                    }}
                >
                    {/* <DialogTitle sx={{ fontWeight: 500 }}>Add Note for Reactivating &nbsp;<Typography sx={{ color: 'var(--primary)', display: 'inline', fontSize: '20px', fontWeight: 500 }} >{name}</Typography></DialogTitle> */}
                    <IconButton
                        onClick={handleCloseClick}
                        sx={{ width: 24, height: 24, marginRight: 3 }}>
                        <Icon.Close />
                    </IconButton>
                </Box>
                <DialogContent
                    sx={{
                        paddingTop: "0px !important"
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: "center",
                            gap: 2
                        }}
                    >
                        <Box
                            sx={{
                                padding: '16px',
                                background: '#fffbeb',
                                borderRadius: '50%',
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Icon.ReportProblemOutlined style={{ fontSize: '32px', color: '#f59e0b' }} />
                        </Box>
                        <Typography variant='h5' fontWeight='600' >Account Inactive</Typography>
                        <Typography variant='subtitle1' sx={{ textAlign: 'center' }}>
                            {parts.map((part, index) => {
                                if (part === 'contact@farwide.com') {
                                    return (
                                        <a
                                            key={index}
                                            href={`mailto:${part}`}
                                            style={{
                                                textDecoration: 'underline',
                                                color: '#26C77A'
                                            }}
                                        >
                                            {part}
                                        </a>
                                    );
                                }
                                return part;
                            })}
                        </Typography>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ p: 3, pt: 0, display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        onClick={() => {
                            window.location.href = `${window.location.origin}/contactus`
                        }}
                        startIcon={<Icon.EmailOutlined />}
                    >
                        Contact Support
                    </Button>
                    <Typography variant='body2' >Our support team typically responds within 24 hours.</Typography>
                </DialogActions>
            </Dialog>
        </>
    )
};


export default ArchivedAcountSupportPopUp;